import { LOCATION } from "../actions/location";
import { REQUEST, SUCCESS, FAILURE } from "../actions";

const initialState = {
  loading: false,
  locations: [],
  error: ""
};
export const locationReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOCATION[REQUEST]:
      return {
        ...state,
        loading: true
      };
    case LOCATION[SUCCESS]:
      return {
        ...state,
        loading: false,
        locations: action.payload
      };
    case LOCATION[FAILURE]:
      return {
        ...state,
        loading: false,
        error: action.payload
      };

    default:
      return state;
  }
};
